"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStaticAssetsBaseUrl = exports.getPlaceholderUrl = void 0;
/**
 * Placeholder image utilities for generating URLs to custom placeholder images stored in S3
 */

// Available placeholder files in S3
var PLACEHOLDER_FILES = {
  '500x300': 'placeholder-500x300-4x.png',
  '900x400': 'placeholder-900x400-4x.png',
  '300x100': 'placeholder-300x100-4x.png',
  300: 'placeholder-300x300-4x.png',
  '16x9': 'placeholder-16x9-4x.png',
  '1x1': 'placeholder-1x1-4x.png',
  '224x126': 'placeholder-224x126-4x.png',
  '150x150': 'placeholder-150x150-4x.png',
  150: 'placeholder-150x150-4x.png',
  '50x50': 'placeholder-50x50-4x.png',
  50: 'placeholder-50x50-4x.png',
  '200x100': 'placeholder-200x100-4x.png'
};

/**
 * Get the base URL for static assets from environment variables
 * @returns {string} Base URL for static assets
 */
var getStaticAssetsBaseUrl = exports.getStaticAssetsBaseUrl = function getStaticAssetsBaseUrl() {
  return process.env.REACT_APP_STATIC_ASSETS_BASE_URL || 'https://studio-assets.app.t2.cvent.com';
};

/**
 * Generate a URL for a custom placeholder image
 * @param {string} dimensions - Dimensions in format like "500x300", "16x9", "1x1", or just "50" for square
 * @returns {string} Complete URL to the placeholder image
 */
var getPlaceholderUrl = exports.getPlaceholderUrl = function getPlaceholderUrl(dimensions) {
  var baseUrl = getStaticAssetsBaseUrl();
  var filename = PLACEHOLDER_FILES[dimensions];
  if (!filename) {
    console.warn("No placeholder file found for dimensions: ".concat(dimensions, ". Using default 500x300."));
    return "".concat(baseUrl, "placeholder/").concat(PLACEHOLDER_FILES['500x300']);
  }
  return "".concat(baseUrl, "placeholder/").concat(filename);
};